import { FeatureFlagOptions } from './types'

export const JURIS_DOCVIEW_REDESIGN_VARIANTS = {
  ENABLED: 'enabled',
} as const

export const GROWTH_BOOK_FEATURE_FLAGS: Record<string, FeatureFlagOptions> = {
  THESIS_SECURITY: {
    name: 'thesis_security_in_juris_docview',
    values: ['accordion', 'card'],
  },
  JURIS_DOCVIEW_REDESIGN: {
    name: 'juris_docview_redesign',
    values: Object.values(JURIS_DOCVIEW_REDESIGN_VARIANTS),
  },
} as const
